module.exports = __webpack_public_path__ + "img/opc-my-son.svg";